import React, { Component, useState, useEffect, useContext } from 'react'

import { withStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  root: {
    position:'relative'
  },
  header: {
    backgroundColor: '#efefef',
    marginLeft: -(theme.spacing(1.5)),
    marginRight: -(theme.spacing(1.5)),
    padding: theme.spacing(1.5)    
  },
  headerSubSection: {    
  },
  title: {
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 800,
  },
  titleSubSection: {
    fontSize: theme.typography.body2.fontSize,
    fontWeight: 600,
    color: '#777'    
  },
  body: {
    
  }
})

const Section = ({ theme, classes, variant, children, ...props}) => {
  
  const { title, gutterBottom } = props
  
  return (
    <Box mb={ gutterBottom ? (variant === 'subsection' ? 2 : 4) : 0 }
      className={classes.root}
      >
      { title &&
        <Box 
          className={variant === 'subsection' ? classes.headerSubSection : classes.header}>
          <Typography 
            component={variant === 'subsection' ? 'h5' : 'h4'}
            className={variant === 'subsection' ? classes.titleSubSection : classes.title}>
            { title }
          </Typography>
        </Box>
      }
      <Box mt={variant === 'subsection' ? 1 : 2} mb={variant === 'subsection' ? 1 : 2}>
        { children }
      </Box>
    </Box>
  )
}

export default withStyles(styles, { withTheme: true })(
  Section
)
